import React from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

import { FileUploader } from '../../../base'
import { FileUploaderProps } from '../../../base/FileUploader/FileUploader'
import { inputProperties } from '../../../types/inputProperties'
import WidgetBody from '../../../base/Widget/WidgetBody'
import PaymentDetailsForm from './PaymentDetailsForm'
import PaymentDetailsReadOnly from './PaymentDetailsReadOnly'
import { PAYMENT_INFORMATION_DESCRIPTION } from '../../../utils/payments'
import WidgetSection from '../../../base/Widget/WidgetSection'

const ALLOWED_FILE_EXTENSIONS = [
  'xls',
  'xlsx',
  'doc',
  'docx',
  'pdf',
  'gif',
  'jpeg',
  'jpg',
]

export interface PaymentDetailsProps {
  accountName: inputProperties
  amount: inputProperties
  form?: UseFormReturn
  accountNumber: inputProperties
  invoiceUploader?: FileUploaderProps
  memo: inputProperties
  onClickBack?: Function
  onSubmit: Function
  isStart?: boolean
  disableDocumentUpload?: boolean
  title: string
  isReadOnlyView: boolean
}

const PaymentDetails = (props: PaymentDetailsProps) => {
  const defaultForm = props.form || useForm()
  const {
    formState: { isSubmitting, defaultValues },
  } = defaultForm

  const onClickContinue = () => {
    props.onSubmit && props.onSubmit()
  }

  const onClickBack = () => {
    props.onClickBack && props.onClickBack()
  }

  return (
    <WidgetBody
      title={props.title}
      onBack={onClickBack}
      onContinue={onClickContinue}
      isSubmitting={isSubmitting}
      ctaLabel='Continue to Review'
    >
      {props.isReadOnlyView ? (
        <PaymentDetailsReadOnly
          accountName={defaultValues?.accountName || props.accountName?.value}
          amount={defaultValues?.amount || props.amount?.value}
          accountNumber={
            defaultValues?.accountNumber || props.accountNumber?.value
          }
          memo={defaultValues?.memo || props.memo?.value}
        />
      ) : (
        <PaymentDetailsForm
          accountName={props.accountName}
          amount={props.amount}
          form={props.form}
          accountNumber={props.accountNumber}
          memo={props.memo}
          disableDocumentUpload={props.disableDocumentUpload}
        />
      )}

      {props.disableDocumentUpload !== true && (
        <WidgetSection
          title={`${PAYMENT_INFORMATION_DESCRIPTION.ATTACHMENTS}${
            props.invoiceUploader?.required ? '' : ' (Optional)'
          }`}
          isLastSection
        >
          <FileUploader
            allowedFileExtensions={ALLOWED_FILE_EXTENSIONS}
            form={defaultForm}
            maxFileNumber={props.invoiceUploader?.maxFileNumber}
            maxFileSize={props.invoiceUploader?.maxFileSize}
            rules={{
              required: {
                value: props.invoiceUploader?.required,
                message: 'At least 1 attachment is required',
              },
            }}
            onError={props.invoiceUploader?.onError}
            uploadingFile={props.invoiceUploader?.uploadingFile}
            {...PaymentDetails.defaultProps.invoiceUploader}
          />
        </WidgetSection>
      )}
    </WidgetBody>
  )
}

PaymentDetails.defaultProps = {
  title: 'Payment Details',
  accountName: {
    label: 'Account Name',
    id: 'accountName',
    name: 'accountName',
    required: true,
  },
  amount: {
    id: 'amount',
    name: 'amount',
    required: true,
  },
  accountNumber: {
    label: 'Account or Invoice Number',
    id: 'accountNumber',
    name: 'accountNumber',
    required: true,
  },
  invoiceUploader: {
    id: 'invoiceUploader',
    dragAndDropLabel: 'Drag & Drop or Click to Browse',
    name: 'invoiceUploader',
    required: false,
  },
  memo: {
    id: 'memo',
    name: 'memo',
    required: false,
  },
  isStart: false,
  disableDocumentUpload: false,
}

export default PaymentDetails
